const IMAGE_OBJECT_POSITION = "center 40%"; // heuristic - most wedding photos have the subject higher up in the frame

export { IMAGE_OBJECT_POSITION };
